import { urls } from "../config";
import { AxiosInstancePrivate } from "../utils/AxiosInstance";

const privateAxios = AxiosInstancePrivate();

export const getImpersonatedActionsLogSearchCriteria = async () => {
	const response = await privateAxios.get(urls.impersonatedActionsLogSearchCriteria);
	return response?.data;
};

export const getSearchResults = async (pagination, sortModel, searchData) => {
	const response = await privateAxios.post(urls.impersonatedActionsLogSearchResult, { pagination, sortModel, ...searchData });
	return response?.data;
};